import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/system",
    name: "system",
    component: dashboard,
    redirect: {
      name: "role"
    },
    children: [
      {
        path: "role",
        name: "role",
        meta: { title: "角色权限管理" },
        component: () => import("@/views/system/role/index.vue"),
        children: [
          {
            path: "roleManage/:id",
            name: "roleManage",
            meta: { title: "角色信息维护" },
            component: () => import("@/views/system/role/roleManage.vue")
          },
          {
            path: "addRole",
            name: "addRole",
            meta: { title: "添加角色" },
            component: () => import("@/views/system/role/addRole.vue")
          }
        ]
      },
      {
        path: "user",
        name: "user",
        meta: { title: "操作用户管理" },
        component: () => import("@/views/system/user/index.vue"),
        children: [
          {
            path: "userManage/:id",
            name: "userManage",
            meta: { title: "用户信息维护" },
            component: () => import("@/views/system/user/userManage.vue")
          }
        ]
      },
      {
        path: "synopsis",
        name: "synopsis",
        meta: { title: "说明书管理" },
        component: () => import("@/views/system/synopsis/index.vue")
      }
    ]
  }
];
